import ResizeObserver from 'resize-observer-polyfill';
import { fromEvent, merge, Observable } from 'rxjs';
import * as op from 'rxjs/operators';

function getRect(ele) {
  if (ele === window) {
    return {
      left: 0,
      top: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    };
  } else {
    return ele.getBoundingClientRect();
  }
}

export function getVisiblePart(target, flowRoot) {
  var targetRect = getRect(target);
  var rootRect = getRect(flowRoot);
  return {
    offsetY: Math.max(0, rootRect.top - targetRect.top),
    offsetX: Math.max(0, rootRect.left - targetRect.left),
    clipRect: {
      left: Math.max(targetRect.left, rootRect.left),
      top: Math.max(targetRect.top, rootRect.top),
      right: Math.min(targetRect.right, rootRect.right),
      bottom: Math.min(targetRect.bottom, rootRect.bottom)
    }
  };
}

function fromResizeEvent(element) {
  if (element === window) {
    return fromEvent(element, 'resize');
  }

  return new Observable(function (subscriber) {
    var resizeObserver = new ResizeObserver(function () {
      subscriber.next();
    });
    resizeObserver.observe(element);
    return function () {
      resizeObserver.disconnect();
    };
  });
}
/** 基于 ResizeObserver 和 scroll event 封装的 RxJS observable；
 * 用于监听一个元素的在页面中的「可见范围」的不断变化 */


export function getVisiblePartObservable(target, flowRoot) {
  return merge(fromEvent(flowRoot, 'scroll', {
    passive: true
  }), fromResizeEvent(flowRoot), fromResizeEvent(target)).pipe(op.map(function () {
    return getVisiblePart(target, flowRoot);
  }));
}